// chat items on left panel
const chatItems = [
  {
    icon: 'fa-comment-dots',
    title: 'Output',
    name: 'chat_output',
    type: 'normal'
  },
  {
    icon: 'fa-keyboard',
    title: 'Input',
    name: 'chat_input',
    type: 'mapping-input'
  },
  {
    icon: 'fa-location-arrow',
    title: 'Jump',
    name: 'jump',
    type: 'nooutput'
  },
  {
    icon: 'far fa-file',
    title: 'Page',
    name: 'page',
    type: 'normal'
  },
  {
    icon: 'fa-project-diagram',
    title: 'Condition',
    name: 'condition',
    type: 'condition-2'
  },
  {
    icon: 'fa-sitemap',
    title: 'Intent mapping',
    name: 'intent_mapping',
    type: 'mapping'
  },
  {
    icon: 'fa-dice',
    title: 'Random',
    name: 'random',
    type: 'random-2'
  },
  {
    icon: 'fa-regular fa-clock',
    title: 'Schedule',
    name: 'schedule',
    type: 'schedule'
  },
  {
    icon: 'fa-arrows-spin',
    title: 'Loop',
    name: 'loop',
    type: 'normal'
  },
  {
    icon: 'far fa-edit',
    title: 'Write',
    name: 'write',
    type: 'normal'
  },
  {
    icon: 'mdi-creation',
    title: 'GenAI',
    name: 'gen_ai',
    type: 'mapping-api'
  },
  {
    icon: 'fa-code',
    title: 'Code',
    name: 'code',
    type: 'mapping-api'
  },
  {
    icon: 'fa-cog',
    title: 'API',
    name: 'api',
    type: 'mapping-api'
  },
  {
    icon: 'far fa-envelope',
    title: 'Mail',
    name: 'mail',
    type: 'mapping-mail'
  },
  {
    icon: 'fa-location-dot',
    title: 'Checkpoint',
    name: 'checkpoint',
    type: 'normal'
  },
  {
    icon: 'fa-stamp',
    title: 'Stamp service',
    name: 'stamp_service',
    type: 'normal'
  },
  {
    icon: 'far fa-smile',
    title: 'Clear retry',
    name: 'clear_retry',
    type: 'normal'
  },
  {
    icon: 'far fa-frown',
    title: '+1 retry',
    name: 'add_retry',
    type: 'normal'
  },
  {
    icon: 'fa-user-times',
    title: 'Disconnect',
    name: 'chat_disconnect',
    type: 'nooutput'
  },
  {
    icon: 'fa-exchange-alt',
    title: 'Transfer',
    name: 'chat_transfer',
    type: 'nooutput'
  },
  {
    icon: 'mdi-math-log',
    title: 'Log',
    name: 'log',
    type: 'normal'
  },
  {
    icon: 'far fa-sticky-note',
    title: 'Note',
    name: 'note',
    type: 'comment'
  }
]

module.exports = chatItems
